/**
 * 指文字ドリル「よむ」の苦手な文字の判定と並び順。
 * 画面から切り離した純粋な関数だけを置く。
 */
import type { FingerspellingEntry } from "./fingerspelling";
import { getDrillPool } from "./fingerspelling-drill";

/** 1文字ぶんの「よむ」の記録。API（GET /fingerspelling/read-stats）のレスポンスと同じ形 */
export type ReadStat = {
  entryId: string;
  attempts: number;
  correctCount: number;
  lastCorrect: boolean;
};

/**
 * 苦手な文字を、正答率の低い順に返す。
 * 苦手 = 記録がない文字、または直近の回答が不正解だった文字。
 * 記録なしは正答率0%、同じ正答率の文字はランダムな順にする。
 * 読む対象にない文字の記録は無視する。件数の上限は付けない。
 */
export const getWeakEntries = (
  stats: readonly ReadStat[],
  random: () => number = Math.random,
): FingerspellingEntry[] => {
  const statById = new Map(stats.map((stat) => [stat.entryId, stat]));
  return getDrillPool("read")
    .flatMap((entry) => {
      const stat = statById.get(entry.id);
      if (stat?.lastCorrect) return [];
      const accuracy =
        stat && stat.attempts > 0 ? stat.correctCount / stat.attempts : 0;
      return [{ entry, accuracy, tieBreaker: random() }];
    })
    .sort((a, b) => a.accuracy - b.accuracy || a.tieBreaker - b.tieBreaker)
    .map(({ entry }) => entry);
};
